const faqData = [
  {
    question: 'How long does installation take?',
    answer:
      'Installation typically takes 2-4 hours. Our professional technicians will coordinate with you to find the perfect time that works for your schedule. We\'ll handle everything from start to finish.',
  },
  {
    question: 'Is there a contract or can I cancel anytime?',
    answer:
      'We offer flexible plans with no long-term contracts. You can cancel anytime with 30 days notice. We believe in earning your business through great service, not binding contracts.',
  },
  {
    question: 'What equipment is included?',
    answer:
      'All plans include a high-performance WiFi router, ONT (Optical Network Terminal), and 50 meters of installation wire at no extra cost. Additional equipment like mesh systems are available upon request.',
  },
  {
    question: 'Do you offer 24/7 customer support?',
    answer:
      'Yes! Our expert support team is available 24/7 via phone, email, and live chat. We\'re here to help whenever you need us, day or night.',
  },
  {
    question: 'What makes fiber internet better than cable?',
    answer:
      'Fiber-optic technology uses light signals instead of electrical signals, providing faster speeds, lower latency, more reliable connections, and symmetrical upload/download speeds. It\'s not affected by weather and offers consistent performance even during peak hours.',
  },
  {
    question: 'Are there any data caps or speed throttling?',
    answer:
      'Absolutely not! We offer truly unlimited data with no caps, no throttling, and no hidden fees. Stream, game, and work as much as you want without worrying about overage charges.',
  },
];

export default faqData;
